import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

// Marka (merkez) etrafında bölgesel hakimiyet takımyıldızı — tüm varlıklar yerel.
const NODES = [
  { name: "Beşiktaş", x: 50, y: 16 },
  { name: "Gayrettepe", x: 78, y: 30 },
  { name: "Fulya", x: 84, y: 60 },
  { name: "Dikilitaş", x: 66, y: 82 },
  { name: "Mecidiyeköy", x: 34, y: 84 },
  { name: "Şişli", x: 16, y: 60 },
  { name: "Levent", x: 22, y: 30 },
  { name: "Etiler", x: 50, y: 50, hero: true },
];

const CENTER = { x: 50, y: 50 };

export const RegionalDominance = () => (
  <section
    className="relative bg-[#050505] py-24 md:py-36 px-6 md:px-12 lg:px-24 overflow-hidden"
    data-testid="trust-regional"
  >
    <div className="grid lg:grid-cols-2 gap-14 lg:gap-16 items-center">
      <Reveal>
        <span className="font-mono text-xs tracking-[0.3em] text-[#C48A5E] uppercase">
          05 — Bölgesel Hakimiyet
        </span>
        <h2 className="mt-5 font-serif text-4xl md:text-6xl text-[#F5F5F0] leading-tight">
          Amaç tüm Türkiye değil.
          <br />
          <span className="italic text-[#C48A5E]">Bölgede ilk tercih.</span>
        </h2>
        <p className="mt-6 font-sans text-base md:text-lg leading-relaxed text-[#A3A09A]">
          Hedef nettir: Beşiktaş ve çevresinde akla gelen ilk premium kasap olmak.
          Her içerik, bu bölgesel liderliği inşa etmek için tasarlanır.
        </p>
        <div className="mt-8 flex flex-wrap gap-2.5">
          {NODES.filter((n) => !n.hero).map((n) => (
            <span key={n.name} className="trust-pill">
              {n.name}
            </span>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15} className="relative aspect-square w-full max-w-lg mx-auto">
        <div
          className="absolute inset-0 rounded-2xl border border-white/5"
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(196,138,94,0.10) 0%, rgba(15,15,15,0) 70%)",
          }}
        />
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          {NODES.filter((n) => !n.hero).map((n) => (
            <line
              key={n.name}
              x1={CENTER.x}
              y1={CENTER.y}
              x2={n.x}
              y2={n.y}
              stroke="rgba(196,138,94,0.22)"
              strokeWidth="0.3"
            />
          ))}
        </svg>

        {NODES.map((n, i) => (
          <motion.div
            key={n.name}
            initial={{ opacity: 0, scale: 0.6 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 + i * 0.08, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
            style={{ left: `${n.x}%`, top: `${n.y}%` }}
          >
            {n.hero ? (
              <div className="relative flex flex-col items-center">
                <span className="absolute -inset-6 rounded-full bg-[#C48A5E]/20 blur-xl animate-pulse" />
                <div className="relative w-3.5 h-3.5 rounded-full bg-[#C48A5E] shadow-[0_0_18px_4px_rgba(196,138,94,0.6)]" />
                <span className="relative mt-2 font-serif text-base text-[#F5F5F0] whitespace-nowrap">
                  Ertan Kasap
                </span>
              </div>
            ) : (
              <>
                <div className="w-1.5 h-1.5 rounded-full bg-[#C48A5E]/70" />
                <span className="mt-1.5 font-mono text-[9px] tracking-[0.1em] text-[#A3A09A] uppercase whitespace-nowrap">
                  {n.name}
                </span>
              </>
            )}
          </motion.div>
        ))}
      </Reveal>
    </div>
  </section>
);

export default RegionalDominance;
